import React from 'react';
import { parseNumberByPrecision } from '@pascal/pascal-core';

const StatisticsItem = ({ item, lastRoundValue }) => {
  const { num, count } = item;

  return (
    <div className='statistics-block-items'>
      <span className='items-number'>{num}</span>
      <div className='items-loading'>
        <span className='loading-percent' style={{ width: `${(count * 80) / lastRoundValue}%` }} />
      </div>
      <span className='items-percent'>{parseNumberByPrecision(1, (100 * count) / lastRoundValue, 2)}%</span>
    </div>
  );
};

export default StatisticsItem;
